import { render, staticRenderFns } from "./editView.vue?vue&type=template&id=63cc0c72&scoped=true&"
import script from "./editView.vue?vue&type=script&lang=js&"
export * from "./editView.vue?vue&type=script&lang=js&"
import style0 from "./editView.vue?vue&type=style&index=0&id=63cc0c72&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc0c72",
  null
  
)

export default component.exports